import { useEffect, useState } from "react";
import { History, RefreshCw } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../ui/table";
import api from "../../lib/api";

const ACTION = {
  user_update: ["Modifica utente", "bg-blue-100 text-blue-800"],
  client_update: ["Modifica cliente", "bg-indigo-100 text-indigo-800"],
  password_set: ["Password impostata", "bg-amber-100 text-amber-800"],
  password_change: ["Cambio password", "bg-stone-200 text-stone-700"],
  impersonate: ["Accesso come utente", "bg-red-100 text-red-700"],
};
const FIELD = { name: "Nome", email: "Email", phone: "Telefono", zone: "Zona", business: "Attività", business_type: "Tipo attività", vat: "P.IVA", address: "Indirizzo", zip: "CAP", city: "Città", province: "Prov.", notes: "Note", commission_rate: "Provvigione %", discount_pct: "Sconto %", agent_id: "Agente", status: "Stato", type: "Tipo", contact: "Referente", email_inviata: "Email inviata" };

const fmt = (iso) => { const d = new Date(iso); return isNaN(d) ? iso : d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }); };
const val = (v) => (v === "" || v == null || v === "None" ? "—" : String(v));

export default function AuditLogPanel() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/audit-log?limit=300").then(({ data }) => setRows(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const list = rows.filter((r) => !q || [r.target_name, r.actor_name, r.action].join(" ").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-6" data-testid="audit-log-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h3 className="font-serif text-xl font-semibold text-[#0B2A45] flex items-center gap-2"><History className="w-5 h-5 text-[#C2593F]" />Storico modifiche <span className="text-stone-400 text-base">({list.length})</span></h3>
        <div className="flex gap-2">
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca utente, cliente, autore…" className="h-9 w-64" data-testid="audit-search" />
          <Button variant="outline" size="sm" onClick={load} className="rounded-full" data-testid="audit-refresh"><RefreshCw className="w-4 h-4" /></Button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Quando</TableHead><TableHead>Chi</TableHead><TableHead>Azione</TableHead><TableHead>Su</TableHead><TableHead>Modifiche</TableHead></TableRow></TableHeader>
          <TableBody>
            {list.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-stone-400">Nessuna modifica registrata</TableCell></TableRow>}
            {list.map((r) => {
              const [label, cls] = ACTION[r.action] || [r.action, "bg-stone-100 text-stone-600"];
              const ch = Object.entries(r.changes || {});
              return (
                <TableRow key={r.id} data-testid={`audit-row-${r.id}`}>
                  <TableCell className="text-xs whitespace-nowrap text-stone-500">{fmt(r.at)}</TableCell>
                  <TableCell className="text-xs"><div className="font-medium">{r.actor_name}</div><div className="text-stone-400">{r.actor_role}{r.impersonated_by ? " · via admin" : ""}</div></TableCell>
                  <TableCell><span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${cls}`}>{label}</span></TableCell>
                  <TableCell className="text-sm font-medium">{r.target_name || r.target_id}</TableCell>
                  <TableCell className="text-xs">
                    {ch.length === 0 ? <span className="text-stone-300">—</span> : ch.map(([k, v]) => (
                      <div key={k}><span className="text-stone-400">{FIELD[k] || k}:</span> {v && typeof v === "object" && "a" in v ? <><s className="text-stone-400">{val(v.da)}</s> → <b>{val(v.a)}</b></> : val(v)}</div>
                    ))}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
